import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import cx from "classnames";
import AutoFocusOnMount from "../../utils/AutoFocusOnMount";
const Sheets = (props) => {
  const {
    className = "",
    fullSize = false,
    prefix = "",
    children,
    open = false,
    closeBtnClick,
    header,
    alignment = "right",
    preserveAlignment = false,
    footer,
    size = "small",
    describedById,
    labelledById,
    ariaLabel,
    ...other
  } = props;
  const classes = cx(
    `${prefix}sheets`,
    `${prefix}sheets--${size}`,
    fullSize && `${prefix}sheets--mobile-full-size`,
    alignment === "left" && `${prefix}sheets--mirrored`,
    preserveAlignment && `${prefix}sheets--preserve-alignment`,
    open ? `${prefix}sheets--enter` : `${prefix}sheets--close`,
    className
  );
  const hookedHeader = header ? React.cloneElement(header, { closeBtnClick, prefix }) : null;
  const hookedFooter = footer && React.cloneElement(footer, { prefix, closeBtnClick, stacked: size === "small" ? footer.props.stacked : false }) || null;
  const hookedBody = React.Children.map(
    children,
    (child) => React.isValidElement(child) ? React.cloneElement(child, { prefix }) : child
  );
  const [wrapperFocus, contentRef] = AutoFocusOnMount();
  return /* @__PURE__ */ jsxs("div", { "aria-describedby": describedById, "aria-labelledby": labelledById, "aria-label": ariaLabel, ...other, className: classes, "aria-modal": "true", role: "dialog", tabIndex: -1, children: [
    hookedHeader && !hookedHeader.props.floating && hookedHeader,
    /* @__PURE__ */ jsx("div", { className: `${prefix}sheets__content-wrapper`, role: "document", tabIndex: 0, ref: contentRef, "data-autofocus": wrapperFocus, children: /* @__PURE__ */ jsxs("div", { className: `${prefix}sheet__content`, children: [
      " ",
      hookedHeader && hookedHeader.props.floating && hookedHeader,
      hookedBody
    ] }) }),
    hookedFooter
  ] });
};
var Sheets_default = Sheets;
export {
  Sheets,
  Sheets_default as default
};
